import { render } from "./MfgWuJianInfoEdit1.vue?vue&type=template&id=b722e216&scoped=true"
import script from "./MfgWuJianInfoEdit1.vue?vue&type=script&lang=js"
export * from "./MfgWuJianInfoEdit1.vue?vue&type=script&lang=js"

import "./MfgWuJianInfoEdit1.vue?vue&type=style&index=0&id=b722e216&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b722e216"]])

export default __exports__